import {
  BikeIcon,
  BusIcon,
  CarIcon,
  CarTaxiFrontIcon,
  CoinsIcon,
  FuelIcon,
  KeyIcon,
  ParkingCircleIcon,
  PlaneIcon,
  PlaneTakeoffIcon,
  RouteIcon,
  ShipIcon,
  TrainFrontIcon,
  TrainIcon,
  TramFrontIcon,
  WrenchIcon,
} from 'lucide-react';

import {
  FLIGHT_CONTEXT_KEYWORDS,
  FUEL_CONTEXT_KEYWORDS,
  TRANSPORT_CONFIG,
  TRANSPORT_CONTEXT_KEYWORDS,
  TRANSPORT_KEYWORDS,
  TRANSPORT_TICKET_KEYWORDS,
  VALID_TRANSPORT_SUBCATEGORIES,
  detectTransportSubcategory,
  detectTransportSubcategoryWithConfidence,
} from '@splitfiesta/core';

export {
  FLIGHT_CONTEXT_KEYWORDS,
  FUEL_CONTEXT_KEYWORDS,
  TRANSPORT_CONFIG,
  TRANSPORT_CONTEXT_KEYWORDS,
  TRANSPORT_KEYWORDS,
  TRANSPORT_TICKET_KEYWORDS,
  VALID_TRANSPORT_SUBCATEGORIES,
  detectTransportSubcategory,
  detectTransportSubcategoryWithConfidence,
};

type TransportIcon = React.ComponentType<{ className?: string }>;

export const TRANSPORT_SUBCATEGORY_ICONS: Record<string, TransportIcon> = {
  car: CarIcon,
  bus: BusIcon,
  train: TrainIcon,
  tram: TramFrontIcon,
  flight: PlaneIcon,
  bike: BikeIcon,
  boat: ShipIcon,
  parking: ParkingCircleIcon,
  taxi: CarTaxiFrontIcon,
  rideshare: CarIcon,
  metro: TrainFrontIcon,
  fuel: FuelIcon,
  toll: CoinsIcon,
  rental: KeyIcon,
  maintenance: WrenchIcon,
  airport: PlaneTakeoffIcon,
  default: RouteIcon,
};

export function getTransportIcon(
  subcategory: string | null | undefined
): TransportIcon {
  if (!subcategory || !(subcategory in TRANSPORT_SUBCATEGORY_ICONS)) {
    return TRANSPORT_SUBCATEGORY_ICONS.default;
  }
  return TRANSPORT_SUBCATEGORY_ICONS[subcategory];
}
